import React, { useState } from 'react';
import { Study } from '../StudyList';
import * as styles from './StudyTags.module.scss';
import { Inline } from 'components/layout';
import { Tag } from 'components/core/Tag/Tag';
import { Icon, IconList, Toast, createToast } from 'components/core';

type Props = {
  tags: Study['tags'];
  removeTag: (tag: string) => Promise<void>;
};

const TagWithDelete = (props: {
  removeTag: Props['removeTag'];
  name: string;
}) => {
  const { name, removeTag } = props;

  const [isLoading, setIsLoading] = useState(false);
  return (
    <Tag
      component="li"
      isLoading={isLoading}
      onRemove={async () => {
        setIsLoading(true);

        try {
          await removeTag(name);
        } catch {
          setIsLoading(false);
          createToast(
            <Toast type="danger">
              Oops! Something went wrong when removing the tag
            </Toast>
          );
        }
      }}
      dataPendoKey="remove-tag-button"
    >
      {name}
    </Tag>
  );
};

export const StudyTags = (props: Props) => {
  const { tags = [], removeTag } = props;

  if (tags.length === 0) return null;

  return (
    <Inline alignX="left" alignY="top" spacing={2} shouldWrap={false}>
      <Icon
        variant="neutral"
        size="xl"
        icon={IconList.light.faTag}
        className={styles.tagIcon}
      />
      <Inline
        alignX="left"
        spacing={2}
        component="ul"
        className={styles.tagList}
        aria-label="Study tags"
      >
        {tags.map((tag) => {
          return (
            <TagWithDelete
              key={`tag-${tag}`}
              name={tag}
              removeTag={removeTag}
            />
          );
        })}
      </Inline>
    </Inline>
  );
};
